<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_9"><a id="CHAPTER03"></a>
CHAPTER 3</h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c8">JOURNAL ENTRY: July 31</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c9">Clouds have moved back in, though they’re high and
thin. It looks like a normal summer day, except for the chill in
the air.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">*</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">“I think it’s time to move the chickens back
into their coop,” I told the boys and Mark over our lunch strategy
meeting. They had come over, one at a time, practicing some stealth
maneuvers Eric was teaching his brother.</p>
<p class="western1">“We can do that, but any reason why?” Jason
asked, munching on half of an egg salad sandwich.</p>
<p class="western1">“It’s starting to smell in there,” I said.
“And they need more space and fresh air. Speaking of the chickens,
I’ve got a dozen eggs I’d like you to take back with you for Amanda
to make deviled eggs for the wedding dinner.”</p>
<p class="western1">“Do you want us to mingle the chicks in with
the adults? I think they’re big enough now,” Eric said. He’d raised
lots of chicks down in Florida so I trust his decision.</p>
<p class="western1">“That would be fine, and it would save us
having to figure out a means of separating them. And before anyone
asks, I know the roosters are a noise threat, so I think you should
butcher them. There are several males in the baby chick batch to
replace the breeding stock, so we should be okay.”</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">The chickens definitely looked happier out in
their yards, scratching and pecking away at the grass that was
uncovered by the windstorm that passed through a few days ago. Not
enough ash had fallen during the brief downpour to matter.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">While Eric and Jason were instructing Mark on
the art of killing and butchering a chicken, I rummaged around in
the barn for a box I knew contained some vases. I had seen some
wildflowers on the hill that had survived the ash and thought they
would be a nice addition to the tables for our celebration in two
days. Two days.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c8">JOURNAL ENTRY: August 1</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c9">Last night we were able to get one channel on the TV
for ten minutes. News and weather seem to be considered as one
lately, as the death toll comes to light. The loss of life has been
horrendous, close to seventy percent of the population. Europe and
Asia were largely spared, as the deadly shards hidden in the ash
fell quickly and are now gone from the cloud.</p>
<p class="c9">The comment was also made that those above the
forty-fifth parallel were spared the worst of the fallout. Spared?
If we were spared, with as bad as it was here, it must have been
unimaginable elsewhere. I guess we’ve been lucky that the first
cloud lasted only a week and not more.</p>
<p class="c9">We will all, though, face a sunless, cold future,
for perhaps two years, maybe more, hopefully less.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_010.vue?0bc46f3a